import { render, staticRenderFns } from "./ModalAddReject.vue?vue&type=template&id=30e6d920&"
import script from "./ModalAddReject.vue?vue&type=script&lang=js&"
export * from "./ModalAddReject.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddReject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports